/**
 * Simple Logging Service
 *
 * @export
 * @class $log
 */
export class $log {
    static log = console.log.bind(console);
    static debug = console.debug.bind(console);
    static info = console.info.bind(console);
    static error = console.error.bind(console);
    static warn = console.warn.bind(console);
}
